import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("demo@dividend.app");
  const [password, setPassword] = useState("Demo1234!");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 grain">
      <div className="hidden lg:flex flex-col justify-between p-12 border-r" style={{borderColor: "var(--border)"}}>
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 border" style={{borderColor: "var(--gain)"}}>
            <div className="w-full h-full" style={{background: "var(--gain)", opacity: 0.7}}/>
          </div>
          <span className="text-sm tracking-[0.3em] uppercase">DIVIDEND TRACKER</span>
        </div>
        <div className="space-y-6 fade-up">
          <p className="label-xs">v1.0 / passive income engine</p>
          <h1 className="font-serif text-6xl xl:text-7xl leading-[1.05] font-light">
            Compound the<br />
            <span style={{color: "var(--gain)"}}>quiet money.</span>
          </h1>
          <p className="text-sm max-w-md" style={{color: "var(--text-secondary)"}}>
            A terminal for tracking what your dividend portfolio actually pays you — to the share, to the day.
          </p>
        </div>
        <div className="text-xs space-y-1" style={{color: "var(--text-secondary)"}}>
          <div>// data via alpha vantage</div>
          <div>// connection: <span style={{color: "var(--gain)"}}>secure</span> <span className="blink">█</span></div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md fade-up">
          <p className="label-xs mb-2">Authenticate</p>
          <h2 className="font-serif text-4xl mb-10">Sign in</h2>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="label-xs block mb-2">Email</label>
              <input
                data-testid="login-email-input"
                className="input-base" type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>
            <div>
              <label className="label-xs block mb-2">Password</label>
              <input
                data-testid="login-password-input"
                className="input-base" type="password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div data-testid="login-error" className="text-xs px-3 py-2"
                style={{background: "var(--loss-bg)", color: "var(--loss)", border: "1px solid var(--loss)"}}>
                {error}
              </div>
            )}

            <button data-testid="login-submit-button" type="submit" disabled={busy} className="btn-primary w-full">
              {busy ? "Authenticating..." : "Enter terminal →"}
            </button>
          </form>

          <p className="text-xs mt-8" style={{color: "var(--text-secondary)"}}>
            No account?{" "}
            <Link to="/register" data-testid="goto-register-link" className="underline" style={{color: "var(--text-primary)"}}>
              Create one
            </Link>
          </p>
          <p className="text-[10px] mt-6" style={{color: "var(--text-secondary)"}}>
            Demo: demo@dividend.app / Demo1234!
          </p>
        </div>
      </div>
    </div>
  );
}
